import {ContentType, Platform, PlatformContentInfo} from "@/components/DownloaderApp/types";
import {getTwitchVod} from "@/components/DownloaderApp/twitch";

function getTotalSeconds(timeStr) {
    const match = timeStr.match(/(\d+)h(\d+)m(\d+)s/);
    if (!match) return 0;

    const [, h, m, s] = match.map(Number);
    return h * 3600 + m * 60 + s;
}

function getTwitchVodFromSec(url) {
    try {
        const params = getQueryParams(url);
        return params.t ? getTotalSeconds(params.t) : undefined;
    } catch (err) {
    }
    return undefined
}

function getKickVodFromSec(url) {
    try {
        const params = getQueryParams(url);
        const fromSec = params.t ? +params.t: undefined;
        return Number.isNaN(fromSec) ? undefined : fromSec;
    } catch (err) {
    }
    return undefined
}


function getQueryParams(url) {
    const params = {};
    const queryString = url.split('?')[1];
    if (!queryString) return params;

    for (const [key, value] of new URLSearchParams(queryString)) {
        params[key] = value;
    }
    return params;
}


export function getClipParamValue(url) {
    try {
        const urlObject = new URL(url);
        //https://kick.com/wariatp2w/clips/clip_01J46JKSDZR8R348BN4BD99GEE
        const clipSegment = urlObject.pathname.split("/").find(s => s.startsWith('clip_'));
        if (clipSegment) {
            const clipId = clipSegment.split("_")[1];
            if (clipId?.length) return clipId;
        }

        const clipIdQueryParam = urlObject.searchParams.get("clip") || "";
        if (clipIdQueryParam.includes("clip_")) {
            return clipIdQueryParam.split("clip_")[1]
        }
    } catch (err) {

    }
    return null
}

export function getVideoId(url) {
    const urlObj = new URL(url);
    const pathParts = urlObj.pathname.split('/');
    return pathParts[pathParts.length - 1];
}

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidUUID(id?: string): boolean {
    return !!id && UUID_REGEX.test(id);
}

export function isKickStreamUrl(url: string): boolean {
    try {
        const streamUrl = new URL(url);
        return streamUrl.hostname === 'stream.kick.com'
            && ['https:', 'http:'].includes(streamUrl.protocol)
            && !streamUrl.username && !streamUrl.password;
    } catch {
        return false;
    }
}

export function getPlatformAndContentTypeByUrl(url?: string): PlatformContentInfo | null {
    url = url || ''

    function startsWithCaseInsensitive(str, prefixes) {
        for (let i = 0; i < prefixes.length; i++) {
            if (str.toLowerCase().startsWith(prefixes[i].toLowerCase())) {
                return true;
            }
        }
        return false;
    }

    const twitches = ["https://www.twitch.tv/", "https://twitch.tv/", "https://m.twitch.tv/"];
    if (startsWithCaseInsensitive(url, twitches) && url.includes("/clip/")) {
        return {platform: 'twitch', type: 'clip'}
    }
    if (startsWithCaseInsensitive(url, ["https://clips.twitch.tv/"])) {
        return {platform: 'twitch', type: 'clip'}
    }


    if (startsWithCaseInsensitive(url, twitches) && (url.includes("/video/") || url.includes("/v/"))) {
        const twitchVodId = (new URL(url)).pathname.split("/").pop();
        return {platform: 'twitch', type: 'vod', id: twitchVodId, fromSec: getTwitchVodFromSec(url)}
    }

    if (startsWithCaseInsensitive(url, twitches)) {
        try {
            const urlObj = new URL(url);
            const vodID = urlObj.searchParams.get('vodID');
            if (vodID) {
                return {platform: 'twitch', type: 'vod', id: vodID, fromSec: getTwitchVodFromSec(url)}
            }
        } catch (err) {
        }
    }

    if (startsWithCaseInsensitive(url, ["https://dashboard.twitch.tv/"])) {
        try {
            const urlObj = new URL(url);
            const pathParts = urlObj.pathname.split('/').filter(Boolean);
            const editIndex = pathParts.indexOf('edit');
            if (editIndex !== -1 && pathParts[editIndex + 1]) {
                return {platform: 'twitch', type: 'vod', id: pathParts[editIndex + 1], fromSec: getTwitchVodFromSec(url)}
            }
        } catch (err) {
        }
    }

    const twitches2 = ["https://www.twitch.tv/videos/", "https://twitch.tv/videos/", "https://m.twitch.tv/videos/"];
    if (startsWithCaseInsensitive(url, twitches2)) {
        const twitchVodId = (new URL(url)).pathname.split("/").pop();
        if (twitchVodId) {
            return {platform: 'twitch', type: 'vod', id: twitchVodId, fromSec: getTwitchVodFromSec(url)}
        }
    }

    if (startsWithCaseInsensitive(url, twitches)) {
        try {
            const urlObj = new URL(url);
            const pathParts = urlObj.pathname.split('/').filter(Boolean);
            if (pathParts.length === 1 && /^[A-Za-z0-9][A-Za-z0-9_]*$/.test(pathParts[0])
                && !['videos', 'directory', 'settings', 'search', 'turbo'].includes(pathParts[0])) {
                return {platform: 'twitch', type: 'live', id: pathParts[0]}
            }
        } catch (err) {
        }
    }

    if (startsWithCaseInsensitive(url, ['https://clips.kick.com/'])) {
        const clipId = getClipParamValue(url);
        if (clipId) {
            return {platform: 'kick', type: 'clip', id: clipId}
        }
    }

    if (startsWithCaseInsensitive(url, ['https://kick.com/'])) {
        const clipId = getClipParamValue(url);
        if (clipId) {
            return {platform: 'kick', type: 'clip', id: clipId}
        }
        const videoId = getVideoId(url);

        if (videoId && (url.includes('/videos/') || url.includes('/video/'))) {
            if (!isValidUUID(videoId)) {
                return null;
            }
            let channel: string | undefined;
            try {
                const segments = new URL(url).pathname.split("/").filter(Boolean);
                const keywordIndex = segments.findIndex(s => s === 'videos' || s === 'video');
                if (keywordIndex > 0) {
                    channel = segments[keywordIndex - 1];
                }
            } catch (err) {
            }
            return {platform: 'kick', type: 'vod', id: videoId, fromSec: getKickVodFromSec(url), ...(channel && {channel})}
        }

        try {
            const urlObj = new URL(url);
            if (/^\/events\/[^/]+\/?$/.test(urlObj.pathname)) {
                const channel = urlObj.searchParams.get('c');
                return channel ? {platform: 'kick', type: 'live', id: channel} : null;
            }
            const [empty, nick, suffix] = urlObj.pathname.split("/")
            console.log({empty, nick, suffix})
            if (empty || !nick || ['settings', 'following', 'browse'].includes(nick)) {
                return null;
            }
            if (!suffix) {
                return {platform: 'kick', type: 'live', id: nick}
            }
            if (suffix === "clips") {
                return {platform: 'kick', type: 'clips', id: nick}
            }
            // If suffix is "videos" without a specific video ID, treat as live channel
            if (suffix === "videos" || suffix === "about") {
                return {platform: 'kick', type: 'live', id: nick}
            }
        } catch (err) {
        }
    }

    if (startsWithCaseInsensitive(url, ['https://www.bitchute.com/', 'https://bitchute.com/', 'https://old.bitchute.com/'])) {
        const videoId = new URL(url).pathname.match(/^\/video\/([A-Za-z0-9]+)\/?$/)?.[1];
        return videoId ? {platform: 'bitchute', type: 'vod', id: videoId} : null;
    }

    if (startsWithCaseInsensitive(url, ['https://rumble.com/'])) {
        try {
            const urlObj = new URL(url);
            const pathParts = urlObj.pathname.split('/').filter(Boolean);

            let rumbleId: string | undefined;
            let fromSec: number | undefined;

            if (pathParts[0] === 'hls-vod' && pathParts[1]) {
                // rumbleId = pathParts[1];
            } else if (pathParts[0] === 'playlists' && pathParts[1]) {
                return {platform: 'rumble', type: 'playlist', id: pathParts[1]}
            } else if ((pathParts[0] === 'embed' || pathParts[0] === 'share') && pathParts[1]) {
                rumbleId = pathParts[1];
            } else if (pathParts[0] === 'shorts' && pathParts[1]) {
                rumbleId = pathParts[1];
                return {platform: 'rumble', type: 'short', id: rumbleId}
            } else if (pathParts[0]?.match(/^v[a-z0-9]+/i)) {
                rumbleId = pathParts[0].split('-')[0];
            }

            if (rumbleId) {
                const startParam = urlObj.searchParams.get('start');
                if (startParam) {
                    const parsed = +startParam;
                    if (!Number.isNaN(parsed)) fromSec = parsed;
                }
                return {platform: 'rumble', type: 'vod', id: rumbleId, ...(fromSec !== undefined && {fromSec})}
            }
        } catch (err) {
        }
    }

    if (startsWithCaseInsensitive(url, ['https://streamscharts.com/'])) {
        try {
            const urlObj = new URL(url);
            const platformParam = urlObj.searchParams.get('platform');
            const rawClip = urlObj.searchParams.get('clip');
            if (platformParam === 'kick') {
                const clipId = getClipParamValue(url);
                if (clipId) {
                    return {platform: 'kick', type: 'clip', id: clipId}
                }
            } else if ((!platformParam || platformParam === 'twitch') && rawClip) {
                return {platform: 'twitch', type: 'clip', id: rawClip}
            }
        } catch (err) {
        }
    }

    if (startsWithCaseInsensitive(url, ['https://kickbot.com/clip/', 'https://www.kickbot.com/clip/'])) {
        try {
            const urlObj = new URL(url);
            const pathParts = urlObj.pathname.split('/').filter(Boolean);
            const clipIndex = pathParts.indexOf('clip');
            const clipId = clipIndex !== -1 ? pathParts[clipIndex + 1] : undefined;
            if (clipId) {
                return {
                    platform: 'direct-playlist',
                    type: 'vod',
                    url: `${window.location.origin}/api/kickbot/${clipId}/playlist.m3u8`,
                }
            }
        } catch (err) {
        }
    }

    try {
        const urlObj = new URL(url);

        if (urlObj.pathname.endsWith(".m3u8")) {
            const isVodVodPlaylist = urlObj.origin === 'https://api.vodvod.top'
                && urlObj.pathname.startsWith('/m3u8/');
            const isProxiedVodVodPlaylist = typeof window !== "undefined"
                && urlObj.origin === window.location.origin
                && urlObj.pathname.startsWith('/api/proxy/api.vodvod.top/m3u8/');
            if (isVodVodPlaylist || isProxiedVodVodPlaylist) {
                return {
                    platform: 'direct-playlist',
                    type: 'vod',
                    url: isVodVodPlaylist
                        ? `${window.location.origin}/api/proxy/${urlObj.host}${urlObj.pathname}${urlObj.search}`
                        : url,
                }
            }
            return {platform: 'direct-playlist', type: 'vod'}
        }

        const rFile = urlObj.searchParams.get('r_file') || '';
        if (rFile.endsWith(".m3u8")) {
            return {platform: 'direct-playlist', type: 'vod'}
        }
    } catch (err) {

    }

    return null
}